(function () {
    'use strict';
    app.controller('resetPasswordController', ['$scope', 'LoginService', '$location', '$cookies', 'AuthenticationService', 'progressBarService', '$rootScope', '$timeout', '$routeParams', 'CommonService', function ($scope, loginService, $location, $cookies, AuthenticationService, progressBarService, $rootScope, $timeout, $routeParams, commonService) {

        $scope.isError = false;
        $scope.isSuccess = false;


        $scope.registrationData = {
            emailId: "",
            registeredPassword: "",
            resetCode: "",
            confirmPassword: ""
        }
        var hideMessage = function () {

            $scope.isError = false;
            $scope.isSuccess = false;
            $scope.isModalError = false;
            $scope.isModalSuccess = false;
        }

        $scope.validatePassword = function (event) {
            commonService.validatePassword($scope, event);
        }

        $scope.resetPassword = function () {
            // Validate user details
            if ($scope.ValidateUserDetails()) {
                progressBarService.showProgressBar();

                var resetPasswordInfo = {
                    eSpectraEmail: $routeParams.userId,
                    eSpectraPassword: angular.element("#resetPassword").val(),
                    eSpectraPasswordResetCode: $routeParams.resetCode
                };

                loginService.resetPassword(resetPasswordInfo).then(function (response) {
                    if (response != null && response.data.message != undefined) {
                        $scope.message = response.data.message;
                        $scope.isError = true;
                        $scope.isSuccess = false;
                        //$timeout(hideMessage, 10000);
                    }
                    else {
                     
                        localStorage.setItem("email", response.data);
                        $scope.message = GetMessage.passwordChangedSuccessfully;
                        $('form[name="resetForm"]').trigger('reset');
                        $('#strength').hide();
                        $scope.isError = false;
                        $scope.isSuccess = true;
                        //$timeout(hideMessage, 10000);

                    }
                    progressBarService.hideProgressBar();
                });
            }
        };

        $scope.ValidateUserDetails = function () {
            var returnVal = true;
            if (angular.element("#resetPassword").val() != '') {
                var password = angular.element("#resetPassword").val();
                var regExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+=-])[A-Za-z\d!@#$%^&*()_+=-]{7,20}$/;

                var isValid = regExp.test(password);
                if (isValid) {
                    $("#resetPassword").removeClass("border-red");
                    $("#resetPassword").siblings("label").find("span").fadeOut();
                } else {
                    //$("#resetPassword").addClass("border-red");
                    if (returnVal) {
                        $("#resetPassword").focus();
                    }
                    $("#resetPassword").siblings("label").find("span").fadeIn();
                    returnVal = false;
                }

                if (angular.element("#resetPassword").val() != angular.element("#confirmPassword").val()) {
                    //$("#confirmPassword").addClass("border-red");
                    if (returnVal) {
                        $("#confirmPassword").focus();
                    }
                    $("#confirmPassword").siblings("label").find("span").fadeIn();
                    returnVal = false;
                }
                else {
                    $("#confirmPassword").removeClass("border-red");
                    $("#confirmPassword").siblings("label").find("span").fadeOut();
                }
            }
            else {
                //$("#resetPassword").addClass("border-red");
                if (returnVal) {
                    $("#resetPassword").focus();
                }
                $("#resetPassword").siblings("label").find("span").fadeIn();
                returnVal = false;
            }

            if (!returnVal) {
                this.reseresetForm.resetPassword.$dirty = true;
                this.reseresetForm.confirmPassword.$dirty = true;
            }

            return returnVal;
        }
    }]);
})();